
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480 256a224 224 0 10-448 0 224 224 0 10448 0zM0 256a256 256 0 11512 0 256 256 0 11-512 0zm272-136v23c13.5 1 26.6 4.6 39.6 8.3 1.5.4 3.1.9 4.6 1.3 8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2l-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5-19.1-2.8-36.6-.4-49.3 5.1-12.9 5.6-18.6 13.1-19.8 19.5-1.8 9.8 2.1 16.5 10.2 21.7 10.6 6.8 26.5 11.3 45.8 16.8l.3.1c17.7 5 38.9 11.1 54.3 21.7 19 13 27.8 33.8 23.6 56.5-4 21.6-18.9 36-37.8 43.6-9.9 4-21.1 6.3-33.1 6.9V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.9c-8.1-1.3-21.8-5.2-32.4-8.4-6.9-2.1-13.8-4.3-20.7-6.5-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3 11.2 3.4 22.7 6.6 28.1 7.4 19.8 2.9 36.5 1.3 48-3.4 11.2-4.5 16.8-11.3 18.3-19.7 1.9-10.5-1.5-18.4-10.2-24.4-12-8.2-26.8-12.3-40.9-16.2-2.3-.6-4.7-1.3-6.9-1.9-17.1-4.8-37-10.5-51.7-19.9-8.1-5.2-15.7-12.1-20.5-21.7-4.9-9.8-6.2-20.8-4-32.8 3.8-20.7 20-35.1 38.6-43.1 7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"}})])
          )
        }
      }
    